import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing a view for filtering products in a third-party betting shop.
 * @extends JetView
 */
export default class FilterProductsThirdBetShopView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing ID input and internal products radio buttons
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"),
                    labelPosition: 'top',
                    placeholder: _('ID'),
                },
                {
                    view: 'radio',
                    name: 'InternalProducts',
                    label: _('Productos Internos?'),
                    labelPosition: 'top',
                    value: 0,
                    options: [
                        { id: 0, value: _('Sí') },
                        { id: 1, value: _('No') },
                    ],
                },
            ],
        };

        // Center-left section containing Name input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                },
            ],
        };

        // Center-right section containing State dropdown
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'State',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
            ],
        };

        // Right section containing Providers combo box
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'Providers',
                    id: 'Providers',
                    label: _('Proveedor'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Upper section combining left, center-left, center-right, and right sections
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Button section with actions for adding, clearing, and consulting products
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Producto Tercero'),
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('accountingProductsThirdBetShopAdd', 'Add'), // Permission check for adding products
                    css: 'prm-accountingProductsThirdBetShopAdd',
                    click: () => {
                        this.app.callEvent('addProductThird:button', [{}]); // Event for adding product
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        this.app.callEvent('productThird:filter', [filterdata]); // Event for filtering products
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and fetches provider data.
     */
    init() {
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Sets content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetProviders', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error handling for the request
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parses the response
                    $$('Providers').define('options', resp.Data); // Defines options for Providers combo
                    $$('Providers').refresh(); // Refreshes the combo box
                },
            });
    }
}

// FILE DOCUMENTED
